import styled from 'styled-components';

export const StyledIcon = styled.i`
  font-size: ${(props) => `${props.size || 1}em`};
  ${(props) => props.iconOnly && 'padding-right: 0px'};
`;

export default StyledIcon;
